var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BTable',_vm._b({scopedSlots:_vm._u([_vm._l((_vm.fields),function(field){return {key:_vm.composeSlotName(field),fn:function(ref){
var index = ref.index;
var item = ref.item;
var value = ref.value;
return [_c('BootstrapTableCell',_vm._b({},'BootstrapTableCell',{ index: index, item: item, value: value },false))]}}})],null,true)},'BTable',{ fields: _vm.fields, items: _vm.items },false))}
var staticRenderFns = []

export { render, staticRenderFns }